'use strict';

var _createForOfIteratorHelper = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, '__esModule', {
  value: true
});

function concat(arrays, length) {
  if (!length) {
    length = arrays.reduce(function (acc, curr) {
      return acc + curr.length;
    }, 0);
  }

  var output = new Uint8Array(length);
  var offset = 0;

  var _iterator = _createForOfIteratorHelper(arrays),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var arr = _step.value;
      output.set(arr, offset);
      offset += arr.length;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return output;
}

exports.concat = concat;